import script from "./ErrorCard.vue?vue&type=script&setup=true&lang=js"
export * from "./ErrorCard.vue?vue&type=script&setup=true&lang=js"

import "./ErrorCard.vue?vue&type=style&index=0&id=5f85960e&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5f85960e"]])

export default __exports__